import GoogleIcon from "@assets/icons/google.svg?react";
import Button from "@components/Button/Button";
import clsx from "clsx";
import { useEffect, useState } from "react";

const PREFERRED_SOURCE_URL =
  "https://www.google.com/preferences/source?q=https://www.thinkchina.sg";

type PreferredSourceApi = {
  init: (options?: { theme?: "light" | "dark"; lang?: string }) => void;
  addPreferredSource: () => void;
};

declare global {
  interface Window {
    PREFERRED_SOURCE?: Array<(preferredSource: PreferredSourceApi) => void>;
  }
}

type GoogleSourceBtnProps = {
  className?: string;
  theme?: "light" | "dark";
};

export default function GoogleSourceBtn({
  className,
  theme = "light",
}: GoogleSourceBtnProps) {
  const [preferredSource, setPreferredSource] =
    useState<PreferredSourceApi | null>(null);

  useEffect(() => {
    window.PREFERRED_SOURCE ??= [];

    window.PREFERRED_SOURCE.push((api) => {
      api.init({ theme });
      setPreferredSource(api);
    });
  }, [theme]);

  const handleClick = () => {
    if (preferredSource) {
      preferredSource.addPreferredSource();
    } else {
      window.open(PREFERRED_SOURCE_URL, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Button
      aria-label="Add ThinkChina as a preferred source on Google"
      className={clsx("h-8", className)}
      icon={<GoogleIcon />}
      iconPosition="left"
      onClick={handleClick}
      size="medium"
      variant="tertiary"
    >
      Add ThinkChina as a preferred source
    </Button>
  );
}
